import { graphql } from '@graphql/gql';

export const AGENDA_DATES = graphql(`
  query AGENDA_DATES($params: AgendaDatesInput!) {
    getAgendaDates(params: $params) {
      data {
        agendaDate
      }
    }
  }
`);
